import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import Analytics from "modules/analytics/AnalyticsService/AnalyticsService";
import { useFeatureFlag } from "services/Flags";
import { isIosPlatform, isNativePlatform } from "utils/platform.helpers";

import useAppVersion from "../useAppVersion/useAppVersion";

export default function AppVersionCheck(): JSX.Element | null {
  const { appVersion, isAppOutdated, minimumAppVersion } = useAppVersion();

  const [forceUpdate, setForceUpdate] = useState(false);

  const isDev = useFeatureFlag("isDev");

  const appStoreUrl = isIosPlatform() ? APP_STORE_URL : PLAY_STORE_URL;

  const handleUpdateClick = () => {
    window.location.href = appStoreUrl;
  };

  const renderForceUpdate = () => (
    <div
      data-modal-backdrop="static"
      className="pointer-events-none fixed inset-0 z-[999] grid h-screen w-screen place-items-center bg-black bg-opacity-60 backdrop-blur-md transition-opacity duration-300"
    >
      <div className="pointer-events-none relative w-auto translate-y-[-50px] transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:max-w-[270px]">
        <div className="shadow-4 dark:bg-surface-dark pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current outline-none">
          <div className="relative flex justify-center p-4 pb-2 text-center text-brand-color">
            To continue using the app, <br />
            please install the latest version
          </div>
          <div className="flex flex-col items-center justify-end rounded-b-md border-t border-brand-color/30 p-4">
            <Button onClick={handleUpdateClick}>Update</Button>
          </div>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    if (forceUpdate) {
      Analytics.track("Forcing app update", {
        appVersion,
        requiredVersion: minimumAppVersion,
      });
    }
  }, [forceUpdate]);

  useEffect(() => {
    if (isNativePlatform() && !isDev && isAppOutdated) {
      setForceUpdate(true);
    }
  }, [isAppOutdated]);

  if (forceUpdate) {
    return renderForceUpdate();
  }

  return null;
}

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.repeatmd.mobile";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/myrepeat-patient-rewards/id6448703360";
